"use client"

export enum AuthMode {
  SignIn = "signin",
  SignUp = "signup",
}
